import { Link } from 'react-router-dom';
import SEOHead from '@/components/base/SEOHead';
import Breadcrumb from '@/components/base/Breadcrumb';
import { aboutData } from '@/mocks/about';

const FORM_SUBMIT_URL = 'https://readdy.ai/api/form/d9pic8hn2trhb35gvg1g';

export default function About() {
  const orgJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '51黑料',
    url: 'https://51heiliao.com/',
    description: aboutData.introduction.slice(0, 150),
    contactPoint: {
      '@type': 'ContactPoint',
      email: aboutData.contact.email,
      contactType: 'customer service',
    },
  };

  const aboutJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于51黑料 - 最新热门黑料爆料聚合平台',
    description: '了解51黑料平台的发展历程、品牌理念和联系方式。51黑料是国内领先的黑料爆料聚合平台。',
    url: 'https://51heiliao.com/about',
    isPartOf: {
      '@type': 'WebSite',
      name: '51黑料',
      url: 'https://51heiliao.com/',
    },
  };

  return (
    <>
      <SEOHead
        title="关于我们 - 51黑料爆料聚合平台"
        description="了解51黑料平台的发展历程、品牌理念和联系方式。51黑料是国内领先的娱乐八卦与黑料爆料聚合平台，致力于为网友提供最新、最全、最劲爆的娱乐圈黑料资讯。"
        keywords="51黑料,关于51黑料,51黑料平台,51黑料爆料,51黑料联系"
        canonicalUrl="https://51heiliao.com/about"
      />
      <script type="application/ld+json">{JSON.stringify(orgJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(aboutJsonLd)}</script>

      <main className="pt-20 pb-14">
        <div className="max-w-4xl mx-auto px-4 md:px-6">
          {/* Breadcrumb */}
          <div className="mb-8">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: '关于我们' },
              ]}
            />
          </div>

          {/* Hero */}
          <section className="text-center mb-14">
            <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
              关于51黑料
            </h1>
            <p className="text-lg text-foreground-500 max-w-2xl mx-auto">
              {aboutData.tagline}
            </p>
          </section>

          {/* Stats */}
          <section className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-14">
            {aboutData.stats.map((stat) => (
              <div key={stat.label} className="bg-background-100 rounded-lg border border-background-200/70 p-5 text-center">
                <p className="font-heading text-2xl md:text-3xl font-bold text-primary-600 mb-1">{stat.value}</p>
                <p className="text-xs text-foreground-500">{stat.label}</p>
              </div>
            ))}
          </section>

          {/* Brand Introduction */}
          <section className="mb-14">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-6 flex items-center gap-2">
              <i className="ri-building-line text-primary-500"></i>品牌介绍
            </h2>
            <div className="bg-background-100 rounded-lg border border-background-200/70 p-6 md:p-8">
              <div className="space-y-4 text-foreground-700 leading-relaxed text-sm">
                {aboutData.introduction.split('\n\n').map((paragraph, index) => (
                  <p key={index}>{paragraph}</p>
                ))}
              </div>
            </div>
          </section>

          {/* Reputation */}
          <section className="mb-14">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-6 flex items-center gap-2">
              <i className="ri-heart-line text-primary-500"></i>用户口碑
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {aboutData.reputation.map((review, index) => (
                <div key={index} className="bg-background-100 rounded-lg border border-background-200/70 p-5">
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: 5 }, (_, i) => (
                      <i
                        key={i}
                        className={`text-sm ${i < review.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}
                      ></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                    "{review.content}"
                  </p>
                  <div className="flex items-center gap-2">
                    <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center text-primary-700 text-xs font-bold">
                      {review.name.charAt(0)}
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-800">{review.name}</p>
                      <p className="text-xs text-foreground-400">{review.role}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* Contact */}
          <section className="mb-14">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-6 flex items-center gap-2">
              <i className="ri-contacts-line text-primary-500"></i>联系我们
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="bg-background-100 rounded-lg border border-background-200/70 p-6">
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-4">联系方式</h3>
                <ul className="space-y-3">
                  <li className="flex items-center gap-3 text-sm text-foreground-600">
                    <div className="w-9 h-9 flex-shrink-0 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                      <i className="ri-mail-line"></i>
                    </div>
                    <span>{aboutData.contact.email}</span>
                  </li>
                  <li className="flex items-center gap-3 text-sm text-foreground-600">
                    <div className="w-9 h-9 flex-shrink-0 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                      <i className="ri-wechat-line"></i>
                    </div>
                    <span>{aboutData.contact.wechat}</span>
                  </li>
                  <li className="flex items-center gap-3 text-sm text-foreground-600">
                    <div className="w-9 h-9 flex-shrink-0 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                      <i className="ri-weibo-line"></i>
                    </div>
                    <span>{aboutData.contact.weibo}</span>
                  </li>
                  <li className="flex items-center gap-3 text-sm text-foreground-600">
                    <div className="w-9 h-9 flex-shrink-0 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                      <i className="ri-map-pin-line"></i>
                    </div>
                    <span>{aboutData.contact.address}</span>
                  </li>
                </ul>
              </div>

              <div className="bg-background-100 rounded-lg border border-background-200/70 p-6">
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-4">给我们留言</h3>
                <form
                  className="space-y-4"
                  data-readdy-form="true"
                  id="contact-form"
                  onSubmit={async (e) => {
                    e.preventDefault();
                    const formEl = e.currentTarget;
                    const honeypot = (formEl.querySelector('[name="phone_alt"]') as HTMLInputElement)?.value?.trim();
                    if (honeypot) {
                      alert('留言已提交，感谢您的反馈！');
                      formEl.reset();
                      return;
                    }
                    try {
                      const formData = new FormData(formEl);
                      const res = await fetch(FORM_SUBMIT_URL, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
                      });
                      const text = await res.text();
                      let parsed;
                      try { parsed = JSON.parse(text); } catch { parsed = null; }
                      if (res.ok && parsed?.code === 'OK') {
                        alert('留言已提交，感谢您的反馈！');
                        formEl.reset();
                      } else {
                        const msg = parsed?.meta?.message || parsed?.message || '提交失败，请稍后重试';
                        alert(msg);
                      }
                    } catch {
                      alert('网络错误，请稍后重试');
                    }
                  }}
                >
                  <div>
                    <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1.5">姓名</label>
                    <input
                      type="text"
                      id="contact-name"
                      name="name"
                      required
                      className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-300 rounded-lg focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                      placeholder="请输入您的姓名"
                    />
                  </div>
                  <div>
                    <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">邮箱</label>
                    <input
                      type="email"
                      id="contact-email"
                      name="email"
                      required
                      className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-300 rounded-lg focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                      placeholder="请输入您的邮箱"
                    />
                  </div>
                  <div>
                    <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1.5">留言内容</label>
                    <textarea
                      id="contact-message"
                      name="message"
                      required
                      maxLength={500}
                      rows={4}
                      className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-300 rounded-lg focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors resize-none"
                      placeholder="请输入您的留言内容（500字以内）"
                    ></textarea>
                  </div>
                  <input
                    type="text"
                    name="phone_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                    className="honeypot-field"
                  />
                  <button
                    type="submit"
                    className="w-full px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium rounded-lg transition-colors whitespace-nowrap"
                  >
                    <i className="ri-send-plane-line mr-2"></i>提交留言
                  </button>
                </form>
              </div>
            </div>
          </section>

          {/* CTA */}
          <section className="text-center py-10 bg-background-100 rounded-lg border border-background-200/70">
            <h2 className="font-heading text-xl font-bold text-foreground-950 mb-3">
              加入51黑料，第一时间掌握热点真相
            </h2>
            <p className="text-sm text-foreground-500 mb-5">
              全网最新、最全、最劲爆的爆料内容，尽在51黑料聚合平台
            </p>
            <Link
              to="/category/zuixin"
              className="inline-flex items-center px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg transition-all whitespace-nowrap"
            >
              <i className="ri-flashlight-line mr-2"></i>立即浏览最新爆料
            </Link>
          </section>
        </div>
      </main>
    </>
  );
}